/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Tag size.
 */
export enum TAG_SIZE {
  /**
   * Regular size.
   */
  REGULAR = '',

  /**
   * Small size.
   */
  SMALL = 'sm',
}

export enum TAG_TYPE {
  /**
   * Red color.
   */
  RED = 'red',

  /**
   * Magenta color.
   */
  MAGENTA = 'magenta',

  /**
   * Purple color.
   */
  PURPLE = 'purple',

  /**
   * Blue color.
   */
  BLUE = 'blue',

  /**
   * Cyan color.
   */
  CYAN = 'cyan',

  /**
   * Teal color.
   */
  TEAL = 'teal',

  /**
   * Green color.
   */
  GREEN = 'green',

  /**
   * Gray color.
   */
  GRAY = 'gray',

  /**
   * Cool gray color.
   */
  'COOL-GRAY' = 'cool-gray',

  /**
   * Warn gray color.
   */
  'WARM-GRAY' = 'warm-gray',
}
